import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20" data-id="element-71">
      <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-73">
          <p className="text-sage-dark font-semibold tracking-wider uppercase text-sm mb-4" data-id="element-74">
            METABOLISMO SILVER 21
          </p>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-forest leading-tight mb-6" data-id="element-75">
            Reactiva tu quema calórica tras los 50 — sin ejercicios de impacto.
          </h1>
          <p className="text-lg text-forest/80 mb-8 leading-relaxed" data-id="element-76">
            ¿Recuerdas ese momento del pantalón que ya no cierra? No es falta de
            voluntad. Es tu nueva biología pidiendo una nueva estrategia.
            Aprende a trabajar CON tus hormonas, no contra ellas.
          </p>
          <a href="https://tendenciasdevalor.com/cart/50034446270631:1?checkout" target="_blank" rel="noopener noreferrer" className="inline-block bg-terracotta text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-terracotta/90 transition-colors shadow-lg hover:shadow-xl" data-id="element-77">
            ¡Sí, quiero mi guía ahora!
          </a>
          <p className="text-sm text-forest/60 mt-4" data-id="element-78">
            Acceso instantáneo · Pago único · Garantía
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-79">
          <img src="https://cdn.magicpatterns.com/uploads/hK87CC64sjHTocfvhtXaGz/heylloyd-image-1779068402037.png" alt="Metabolismo Silver 21" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-80" />
        </motion.div>
      </div>
    </section>;
}